import { render } from "./rsy-ads-page-action.vue?vue&type=template&id=3867e085"
import script from "./rsy-ads-page-action.vue?vue&type=script&lang=js"
export * from "./rsy-ads-page-action.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__